import logo from "../../../assets/logo.png"
import {UilInstagram, UilLinkedin} from "@iconscout/react-unicons";
import "./Footer.css"
import {NavLink} from "react-router-dom";

const Footer = () => {
    return (
        <div className={"footer-container"}>
            <div className="footer">
                <img src={logo} alt="logo"/>
                <div className={"footer-list"}>
                    <ul>
                        <li>
                            <NavLink
                                to="/"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                HOME
                            </NavLink></li>
                        <li>
                            <NavLink
                                to="/laboratory"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                LABORATORY
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/portfolio"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                PORTFOLIO
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/team"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                TEAM
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                CONTACT
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className={"footer-icons"}>
                    <a target="_blank" href="https://www.instagram.com/arnikup/" rel="noreferrer"><UilInstagram/></a>
                    <a target="_blank" href="https://www.linkedin.com/company/arnikup/" rel="noreferrer"> <UilLinkedin/></a>
                </div>
                <div className={"footer-end-line"}>
                    <p>© 2024 Arnikup Company. All Rights Reserved</p>
                    <p>Terms & Conditions</p>
                </div>
            </div>
        </div>
    )
}
export default Footer;